<template>
  <div class="CIT_background">
    <div class="position" style="display: flex; flex-direction: column">
      <div class="container_CIT02">
        <div class="block">
          <Card :imgUrl="Card_img" />
        </div>
      </div>
    </div>
    <CRow
      style="
        display: flex;
        justify-content: center;
        margin-left: auto;
        margin-right: auto;
      "
    >
      <div class="button button_setting">
        <CCol col="8">
          <div style="font-size: 18px">START</div>
        </CCol>
        <CCol col="2">
          <i class="fas fa-caret-right fa-5x" style=""></i>
        </CCol>
      </div>
    </CRow>
  </div>
</template>

<script>
import Button from "../../components/signInCss/Button.vue";
import Card from "@/components/elements/Card";

export default {
  components: { Button, Card },
  name: "LKI02",
  props: {
    // used for receive data from Parent
    // Syntax: Name of variable of Parent : Type of variable
    // Example => Courses : Array,
  },
  data() {
    return {
      Card_img:
        "https://cdn4.iconfinder.com/data/icons/ionicons/512/icon-image-512.png",
      // used for declare local variable to use in this class
      // Syntax : Name of variable : Default value
      // Example => courses: []
    };
  },
  methods: {
    // used for define functions in each case
    // Syntax : Name of method(){ Actions }
    // Example => onLogin(){ this.$store.dispatch('auth/onLogin') }
  },
  computed: {
    // used for detect data, in this project usually detect the response data from API
    // that collect in the getters of store (vuex)
    // bringing mapGetters to detect in getters of store (vuex)
    // syntax : ...mapGetters({ Name created variable for local data : Name of getters in store })
    // Example => ...mapGetters({ courses : 'courses/allCourses' })
  },
  watch: {
    // used to manage data after detect data
    // Syntax : Existing name of local variable : function(value){ Action }
    // Example => course : function(value){ this.data = value }
    // Value in parameter is the value of detected data changing
  },
  created() {
    // used for manage event when this page open
  },
  mounted() {
    // used for manage event when data has changed
  },
  beforeDestroy() {
    // used for update value before close this page
    // สมมติว่าจับเวลาใช้ในหน้านี้กี่นาที ให้มาเก็บในนี้
  },
};
</script>

<style scoped lang="scss">
.CIT_background {
  background-color: #e6efff;
}
.position {
  display: flex;
  align-content: center;
  justify-content: center;
}
.block {
   width: 450px;
  height: 450px;
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: aquamarine;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 20px;
}
.card {
 width: 400px;
  height: 400px;
  background-color: white;
  border-radius: 20px; /* 5px rounded corners */
  border: 0px solid;
  margin: 0;
  display: flex;
  justify-content: center;
}

.container_CIT02 {
  margin-left: auto;
  margin-right: auto;
    margin-top: 12%;
}
.button_setting {
  background-color: #89abe6;
  color: white;
  text-align: center;
  text-decoration: none;
  font-size: 12px;
  border-radius: 10px !important;
  box-shadow: none;
  margin-top: 3%;
  margin-bottom: 5%;
  width: 250px;
  height: 70px;
}
@media screen and (min-width: 300px) and (max-width: 600px)  {

  .block {
    width: 250px;
    height: 250px;
    margin-top: 10%;
  }
  .card {
    width: 200px;
    height: 200px;
  }
  .btn-prev {
    width: 50px;
    height: 50px;
    padding: 10px;
    right: 102%;
  }
  .bg-image {
    height: 700px;
  }
  .button_setting{
    width: 150px;
    height: 50px;
  }
}
</style>